import { REDUCER_ACTION } from '../actions/Orgchart/types';
import { GET_ORGCHART_STAFF } from '../actions/Orgchart/action_types';
import { IOrgChartStaff } from '../interfaces/orgchart';
import { ERole } from '../constants/role';

const initialState: IOrgChartStaff = {
  id: 0,
  fullName: '',
  staffCode: '',
  phoneNumber: '',
  companyId: 0,
  email: '',
  department: {
    departmentId: 0,
    departmentName: '0',
    roleTitle: ERole.sale,
  },
};

function orgChartReducer(
  state: IOrgChartStaff = initialState,
  action: REDUCER_ACTION
) {
  switch (action.type) {
    case GET_ORGCHART_STAFF:
      return { ...state, ...action.staff };
    default:
      return state;
  }
}

export default orgChartReducer;
